
  import { ensureAuthenticated } from './core/authGuard.js';
  // Raiz pública: visitante deslogado vai pra landing (marketing) no site.
  // No app (Capacitor) não há landing — vai direto pro login.
  const unauthRedirect = window.__MAPIARE_NATIVE__ ? '/login.html' : '/landing.html';
  await ensureAuthenticated({ unauthRedirect });
